import { a as ne, j as e, c as ae } from "./country-d4e42059.js";
import { useRef as O, useState as y, useEffect as f } from "react";
import { s, d as ie, u as te, a as le, B as re, c as oe, Q as ce } from "./index-384e14bf.js";
import { u as de, C as me, E as ue, A as he } from "./index-6f309963.js";
import { u as W, b as xe, a as z, c as G, k as J, l as D, j as pe, m as fe } from "./index-23ca9bfe.js";
import { M as ge, H as ve, N as je } from "./index-6b21cdcf.js";
import { i as M } from "./lib-1be19634.js";
import { L as Ne } from "./reactNode-61f1c13f.js";
import { L as ye } from "./LoginOpt-0950fbbf.js";
const Ee = function(g) {
  var K;
  const { isModal: m, lang: a, loginData: l, setStep: w, handleBackClick: C } = g, { getStarted: n, errorcode: E } = a, v = W(), x = O(null), [H, j] = y(!1);
  let u = null, o = null, r = null, b = null, h = null, c = null;
  m ? (u = l == null ? void 0 : l.user_id, o = l == null ? void 0 : l.email, r = l == null ? void 0 : l.avatar, b = (K = l == null ? void 0 : l.vip) == null ? void 0 : K.is_vip) : (u = v.get("userId"), o = v.get("email"), r = v.get("avatar"), b = v.get("vip") != "0", h = v.get("referral_code"), c = v.get("invited_source"));
  const p = ne(), [N, B] = y(""), [S, F] = y(0), {
    setUserId: P,
    setEmail: I,
    defaultLoginCallBack: Q,
    handleAuthLoginForEmail: i,
    handleAuthSendEmailMagicLink: k,
    userInfo: T,
    error: d,
    setError: R
  } = xe(), { openNotification: U } = z(), L = G();
  f(() => {
    B("");
  }, []), f(() => {
    const t = d == null ? void 0 : d.code, $ = t ? E[t] : (d == null ? void 0 : d.message) ?? "";
    B($);
  }, [JSON.stringify(d)]);
  const Y = de();
  f(() => {
    o && I(o);
  }, [o]), f(() => {
    P(u);
  }, [u]), f(() => {
    Y || Q(T);
  }, [T]);
  const Z = (t) => {
    R(""), (t == null ? void 0 : t.length) === 6 && i(t);
  }, X = (t) => {
    var A;
    const $ = t == null ? void 0 : t.code;
    let _ = E[$];
    return $ === 40006 && (_ = D(_, {
      retry_after: (A = t == null ? void 0 : t.errors) == null ? void 0 : A.retry_after
    })), { transErr: _ };
  }, ee = () => new Promise((t, $) => {
    J({ email: o }).then(() => {
      F((/* @__PURE__ */ new Date()).getTime()), U({
        type: "success",
        message: null,
        description: n.resendEmailCode
      }), t();
    }).catch((_) => {
      if (_.message.indexOf("41260") > -1) {
        $(_);
        return;
      }
      const { transErr: A } = X(_);
      U({
        type: "error",
        message: null,
        description: A ?? _.message ?? n.optError
      });
    });
  }), V = () => {
    k(), x.current && x.current.toggleHavingTrouble(!1);
  }, [q, se] = y(null);
  return f(() => {
    const t = document.getElementById("right-container");
    se(t);
  }, []), /* @__PURE__ */ e.jsxs(e.Fragment, { children: [
    /* @__PURE__ */ e.jsx("div", { className: s.phoneNumber, children: /* @__PURE__ */ e.jsxs("div", { className: s.optBox, children: [
      r && r != "null" ? /* @__PURE__ */ e.jsx("div", { className: s.avatar, children: /* @__PURE__ */ e.jsxs("div", { className: s.avatar_content, children: [
        /* @__PURE__ */ e.jsx(
          "img",
          {
            className: s.avatar_img + " " + (b ? s.avatar_vip : ""),
            src: r,
            alt: "avatar"
          }
        ),
        b ? /* @__PURE__ */ e.jsx(ge, { className: s.avatar_icon }) : null
      ] }) }) : null,
      /* @__PURE__ */ e.jsxs("div", { className: s.newUser, style: { marginTop: u ? 5 : 40 }, children: [
        /* @__PURE__ */ e.jsxs("div", { className: s.newUser_title, children: [
          u ? n == null ? void 0 : n.welcomeBack : n == null ? void 0 : n.signUpAnAccount,
          " 🎉"
        ] }),
        /* @__PURE__ */ e.jsxs("div", { className: s.newUser_tip, children: [
          /* @__PURE__ */ e.jsx("div", { children: n == null ? void 0 : n.enterOTP }),
          /* @__PURE__ */ e.jsx("div", { className: s.newUser_email, children: o })
        ] })
      ] }),
      /* @__PURE__ */ e.jsx(
        me,
        {
          lang: g.lang,
          autoFocus: !0,
          onChange: Z,
          error: N,
          sendOpt: ee,
          number: S
        }
      ),
      M ? /* @__PURE__ */ e.jsx(
        "span",
        {
          className: s.needHelpTextMobile,
          onClick: () => j(!0),
          children: (n == null ? void 0 : n.needHelpText) || "Need help?"
        }
      ) : /* @__PURE__ */ e.jsx(
        ve,
        {
          ref: x,
          isModal: m,
          render: () => /* @__PURE__ */ e.jsxs(e.Fragment, { children: [
            /* @__PURE__ */ e.jsxs("div", { children: [
              /* @__PURE__ */ e.jsx("i", { className: s.dotBox }),
              n.checkSpamEmail
            ] }),
            /* @__PURE__ */ e.jsxs("div", { children: [
              /* @__PURE__ */ e.jsx("i", { className: s.dotBox }),
              n.havingTrouble,
              " ",
              /* @__PURE__ */ e.jsx(
                "span",
                {
                  className: s.link,
                  onClick: () => m ? w() : h && c ? L.push(`/${p}/get-started?referral_code=${h}&invited_source=${c}`) : L.push(`/${p}/get-started`),
                  children: n.otherOptions
                }
              )
            ] }),
            /* @__PURE__ */ e.jsxs("div", { children: [
              /* @__PURE__ */ e.jsx("i", { className: s.dotBox }),
              n.alternatively,
              " ",
              /* @__PURE__ */ e.jsx("span", { className: s.link, onClick: () => V(), children: n.magicLinkText || n.magicLink })
            ] })
          ] }),
          children: /* @__PURE__ */ e.jsx("span", { className: s.needHelpText, children: (n == null ? void 0 : n.needHelpText) || "Need help?" })
        }
      )
    ] }) }),
    q && ae.createPortal(/* @__PURE__ */ e.jsxs(
      "div",
      {
        className: s.backBox,
        onClick: () => m ? C == null ? void 0 : C() : h && c ? L.push(`/${p}/get-started/email?referral_code=${h}&invited_source=${c}`) : L.push(`/${p}/get-started/email`),
        children: [
          /* @__PURE__ */ e.jsx("svg", { xmlns: "http://www.w3.org/2000/svg", width: "16", height: "16", fill: "none", children: /* @__PURE__ */ e.jsx(
            "path",
            {
              fill: "#707070",
              d: "m13.484 14.557-3.556-3.556 3.556-3.557a.913.913 0 1 0-1.292-1.293L7.984 10.36a.913.913 0 0 0 0 1.292l4.208 4.208a.913.913 0 0 0 1.292 0 .932.932 0 0 0 0-1.302Z"
            }
          ) }),
          /* @__PURE__ */ e.jsx("span", { children: n.back })
        ]
      }
    ), q),
    /* @__PURE__ */ e.jsx(
      je,
      {
        open: H,
        onClose: () => j(!1),
        render: () => /* @__PURE__ */ e.jsxs(e.Fragment, { children: [
          /* @__PURE__ */ e.jsx("div", { className: s.havingTroubleMobileTitle, children: (n == null ? void 0 : n.needHelpTitle) || "Need help" }),
          /* @__PURE__ */ e.jsxs("div", { className: s.havingTroubleEmailMobile, children: [
            /* @__PURE__ */ e.jsxs("div", { children: [
              /* @__PURE__ */ e.jsx("i", { className: s.dotBox }),
              n.checkSpamEmail
            ] }),
            /* @__PURE__ */ e.jsxs("div", { children: [
              /* @__PURE__ */ e.jsx("i", { className: s.dotBox }),
              n.havingTrouble,
              " ",
              /* @__PURE__ */ e.jsx(
                "span",
                {
                  className: s.link,
                  onClick: () => m ? w() : h && c ? L.push(`/${p}/get-started?referral_code=${h}&invited_source=${c}`) : L.push(`/${p}/get-started`),
                  children: n.otherOptions
                }
              )
            ] }),
            /* @__PURE__ */ e.jsxs("div", { children: [
              /* @__PURE__ */ e.jsx("i", { className: s.dotBox }),
              n.alternatively,
              " ",
              /* @__PURE__ */ e.jsx("span", { className: s.link, onClick: () => V(), children: n.magicLinkText || n.magicLink })
            ] })
          ] })
        ] })
      }
    )
  ] });
}, be = /* @__PURE__ */ e.jsx(Ne, { style: { fontSize: 24, color: "#fff" }, spin: !0 }), ke = (g) => {
  const m = G(), {
    lang: { getStarted: a = {}, errorcode: l },
    isModal: w = !1,
    handleEmailClick: C,
    setLoginData: n
  } = g, [E, v] = y(""), [x, H] = y(!0), [j, u] = y(!1), o = fe(), r = O(null), b = O(null), { openNotification: h } = z(), [c, p] = y(""), N = O(c), { blogAddressUrl: B } = pe(), S = (i) => {
    var d;
    const k = i == null ? void 0 : i.code;
    let T = l[k];
    return k === 40006 && (T = D(T, {
      retry_after: (d = i == null ? void 0 : i.errors) == null ? void 0 : d.retry_after
    })), { transErr: T };
  };
  f(() => {
    N.current = c;
  }, [c]);
  const F = W();
  f(() => {
    b.current = x;
  }, [x]), f(() => {
    E && (r.current = E);
  }, [E]);
  const P = (i) => {
    i.key === "Enter" && i.keyCode === 13 && !b.current && N.current && I();
  };
  f(() => (window.addEventListener("keydown", P), () => window.removeEventListener("keydown", P)), [P]);
  const I = () => {
    j || (u(!0), J({
      email: r.current,
      cf_token: window.location.href.includes("localhost") ? void 0 : N.current
    }).then((i) => {
      var d, R;
      const { user_id: k, avatar: T } = (i == null ? void 0 : i.data) ?? {};
      if (w)
        n({ ...i == null ? void 0 : i.data, email: r.current });
      else if (k) {
        const U = (R = (d = i == null ? void 0 : i.data) == null ? void 0 : d.vip) == null ? void 0 : R.is_vip;
        m.push(
          `${o}?step=2&email=${r.current}&userId=${k}&avatar=${T}&vip=${U}&${F.toString()}`
        );
      } else
        m.push(
          `${o}?step=2&email=${r.current}&${F.toString()}`
        );
    }).catch((i) => {
      const { transErr: k } = S(i);
      h({
        type: "error",
        message: null,
        description: k ?? i.message ?? a.optError
      });
    }).finally(() => u(!1)));
  }, Q = D(a.agreement, {
    value1: `<a
        target='_blank'
        style='color: inherit;text-decoration: underline;'
        href=${B.PrivacyPolicy} rel="noreferrer"
      >
          ${a.termsOfUse}
      </a>`,
    value2: `<a
        target='_blank'
        style='color: inherit;text-decoration: underline;'
        href=${B.PrivacyPolicy} rel="noreferrer"
      >
        ${a.privacyPolicy}
      </a>`
  });
  return /* @__PURE__ */ e.jsxs(e.Fragment, { children: [
    /* @__PURE__ */ e.jsx("div", { style: { marginTop: 50 }, className: s.emailTitle, children: a == null ? void 0 : a.enterYourEmail }),
    /* @__PURE__ */ e.jsx("div", { className: s.emailTip, children: a == null ? void 0 : a.verificationEmailCode }),
    /* @__PURE__ */ e.jsxs("div", { className: s.phoneNumber, children: [
      /* @__PURE__ */ e.jsx("div", { className: s.item, children: /* @__PURE__ */ e.jsx(
        ue,
        {
          lang: g.lang,
          setEmail: v,
          setDisable: H,
          email: E,
          placeholder: a.emailLabel
        }
      ) }),
      /* @__PURE__ */ e.jsx(
        he,
        {
          value: c,
          setTurnstileValue: (i) => {
            p(i);
          },
          children: /* @__PURE__ */ e.jsx("button", { className: s.btn, disabled: x, onClick: I, children: j ? /* @__PURE__ */ e.jsx(ie, { indicator: be }) : a.continue })
        }
      )
    ] }),
    /* @__PURE__ */ e.jsx(
      ye,
      {
        isEmail: !0,
        secondMax: 3,
        listItem: 0,
        handleEmailClick: C,
        lang: g.lang,
        isModal: w
      }
    ),
    /* @__PURE__ */ e.jsx("div", { className: s.agreement, children: /* @__PURE__ */ e.jsx(
      "p",
      {
        className: s.msg,
        dangerouslySetInnerHTML: { __html: Q }
      }
    ) })
  ] });
}, Oe = (g) => {
  const {
    lang: m,
    isModal: a = !1,
    handleEmailClick: l,
    setLoginData: w,
    stepModal: C,
    loginData: n,
    setLoginType: E,
    handleBackClick: v,
    bannerType: x
  } = g, j = W().get("step"), [u, o] = y(1), [r, b] = y(!1), h = O(null);
  f(() => {
    if (a) {
      o(C);
      return;
    }
    const N = [1, 2].includes(+j);
    o(j && N ? Number(j) : 1);
  }, [j, a, C]), te(x);
  const c = (N) => {
    b(N), N && h.current.getQrCodeFun();
  }, p = /* @__PURE__ */ e.jsxs(
    "div",
    {
      style: M || a ? {} : {
        width: 1024,
        height: 640,
        display: "flex",
        flexDirection: "row",
        padding: 16,
        borderRadius: 16,
        boxShadow: "0px 4px 6px 0px rgba(162, 183, 203, 0.10)"
      },
      className: s.container,
      children: [
        !(M || a) && /* @__PURE__ */ e.jsx("div", { className: s.leftContainer, children: /* @__PURE__ */ e.jsx(le, { bannerType: x, dictionary: m }) }),
        /* @__PURE__ */ e.jsxs("div", { id: "right-container", style: M || a ? {} : { flex: 1, padding: "20px 34px" }, className: s.rightContainer, children: [
          !M && !a && /* @__PURE__ */ e.jsx(
            "div",
            {
              onClick: () => {
              },
              style: {
                position: "absolute",
                top: 20,
                left: 34,
                width: 45,
                height: 45
                // cursor: 'pointer'
              },
              children: /* @__PURE__ */ e.jsx(re, {})
            }
          ),
          /* @__PURE__ */ e.jsx(
            oe,
            {
              setQrCode: c,
              qrCode: r,
              dictionary: m,
              isModal: a
            }
          ),
          /* @__PURE__ */ e.jsx("div", { className: r ? s.qrCodeWrapper : "hide", children: /* @__PURE__ */ e.jsx(ce, { ref: h, open: r, lang: m }) }),
          /* @__PURE__ */ e.jsxs(
            "div",
            {
              style: {
                width: "100%",
                padding: !(a || M) && "0px 100px"
              },
              className: r ? "hide" : s.loginItems,
              children: [
                u === 1 && /* @__PURE__ */ e.jsx(
                  ke,
                  {
                    lang: g.lang,
                    setLoginData: w,
                    isModal: a,
                    bannerType: x,
                    handleEmailClick: l
                  }
                ),
                u === 2 && /* @__PURE__ */ e.jsx(
                  Ee,
                  {
                    lang: g.lang,
                    isModal: a,
                    handleBackClick: v,
                    loginData: n,
                    setStep: E
                  }
                )
              ]
            }
          )
        ] })
      ]
    }
  );
  return /* @__PURE__ */ e.jsx(e.Fragment, { children: a ? p : /* @__PURE__ */ e.jsxs("div", { className: s.main, children: [
    /* @__PURE__ */ e.jsx("div", { className: s.bg }),
    p
  ] }) });
};
export {
  Oe as E
};
//# sourceMappingURL=EmailLogin-354f278c.js.map
